import React from "react";

import { ZeosFontSize } from "../../services/helpers/ThemeHelpers";
import { ZeosLabel } from "./ZeosLabel";

interface IZeosRadioGroupProps {
  label?: string;
  name: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  layout?: "vertical" | "horizontal";
  required?: boolean;
}

export const ZeosRadioGroup = (props: IZeosRadioGroupProps) => {
  const {
    label,
    name,
    options,
    value,
    onChange,
    disabled,
    layout = "vertical",
    required = false,
  } = props;
  return (
    <div className={`${layout === "vertical" ? "mb-2" : "mb-8"}`}>
      {label && <ZeosLabel label={label} htmlFor={name} required={required} />}
      <div
        className={`flex ${
          layout === "vertical" ? "flex-col gap-2" : "flex-row gap-4"
        }`}
      >
        {options.map((option) => (
          <label
            key={option}
            className={`inline-flex items-center gap-2 text-${ZeosFontSize.lg} font-light text-zeos-black font-sans`}
          >
            <input
              type="radio"
              name={name}
              value={option}
              checked={value === option}
              onChange={() => onChange(option)}
              disabled={disabled}
              className="
              appearance-none relative w-4 h-4 border-2 border-zeos-grey-dk rounded-full
              bg-white cursor-pointer checked:border-zeos-orange-dk disabled:opacity-50
              before:content-[''] before:absolute before:top-1/2 before:left-1/2
              before:-translate-x-1/2 before:-translate-y-1/2
              before:w-2.5 before:h-2.5 before:rounded-full
              checked:before:bg-zeos-orange-dk
            "
            />
            <span className="whitespace-nowrap">{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
